<template>
    <v-container>
        <v-card>


                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="text-h4 text-center">
                            <h2 class="text-center ">Deja libre tu imaginación</h2> 
                        </v-col>
                    </v-row>
                    <v-row wrap>
                        <v-col xs="12" xl="6">
                            <p>Sube aqui tu idea</p>
                            <DropFile @uploadedFiles="saveFiles"></DropFile>
                            
                        </v-col>
                        <v-col xs="12" xl="6">
                            <v-col cols="12">        
                                <v-textarea
                                    name="input-7-1"
                                    label="¿Cual es tu idea?"
                                    v-model="texto"
                                    ></v-textarea>
                                </v-col>
                            <v-col cols="12">
                                <p>Selecciona colores</p>
                                <v-row wrap>
                                    <div class="selectionColors" :style="{backgroundColor: i}" :class="{selectedColor: dSelectedColor.indexOf(i) != -1}"  @click="  dSelectedColor.indexOf(i) == -1 ? dSelectedColor.push(i): dSelectedColor.splice(dSelectedColor.indexOf(i),1) " v-for="i in colors" :key="i"></div>
                                </v-row>
                            </v-col>
                        </v-col>
                        </v-row>
                        <v-row>
                         <v-col xs="12" class="text-center">
                           <v-btn class="mx-auto" color="#7ACBD6" light @click="addToCart()">Comprar</v-btn>
                        </v-col>
                        </v-row>
                        <v-row class="mt-12">
                        <v-col cols="12" >
                           <h2 class="text-center">¿Como funciona?</h2> 
                            <p class="text-center">Envianos tu idea y tu prenda de ropa por correo. Una vez la recibamos uno de nuestros especialistas plasmará tu idea en la prenda. Una vez tengamos tu prenda de ropa la tendremos lista en un plazo maximo de 10 a 15 dias. Nosotros te la envolvemos y te la enviamos para que puedas disfrutar de ella.</p>
                        </v-col>
                        <v-col cols=12>
                                <h2 class="text-center">Algunos de nuestros diseños</h2> 

                                <v-carousel hide-delimiters class="mx-auto">
                                    <v-carousel-item
                                    v-for="(item,i) in carrouselItems"
                                    :key="i"
                                    reverse-transition="fade-transition"
                                    transition="fade-transition"
                                    >
                                        <v-img :src="item.src" width="500" class="mx-auto" :aspect-ratio="1"></v-img>
                                    </v-carousel-item>
                                </v-carousel>
                        </v-col>
                        </v-row>
               
                </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import DropFile from './DropFile.vue'
export default {
  components: { DropFile },
    data(){return {
        colors:['#420420', '#004242', '#4682b4', '#36648b', '#008000', '#66cdaa',"#bada55","#133337",
        "#065535", 
        "#065535", 
        "#8b0000", 
        "#6897bb", 
        "#0e2f44", 
        "#468499", 
        "#003366",
        "#ad9dfb", 
        "#e6e6fa", 
        "#3af91d", 
        "#ff5c19", 
        "#c91d07", 
        "#d11621", 
        "#f00c51"],
        texto:"",
        configureItemModal:true,
        dSelectedColor: [],
        files: [],
        carrouselItems:[{id:1, src: require('../assets/1.jpg')},{id:2, src: require('../assets/2.jpg')},{id:3, src: require('../assets/3.jpg')},{id:4, src: require('../assets/4.jpg')}],
        items:[{id: "cam1", name:"Camiseta 1", price:20, desc:"Descripcion de camiseta", rating:2 },{id: "cam1", name:"Camiseta 1", price:20, desc:"Descripcion de camiseta", rating:2 },{id: "cam1", name:"Camiseta 1", price:20, desc:"Descripcion de camiseta", rating:2 },{id: "cam1", name:"Camiseta 1", price:20, desc:"Descripcion de camiseta", rating:2 },{id: "cam1", name:"Camiseta 1", price:20, desc:"Descripcion de camiseta", rating:2 }]
    }},
    methods:{
        saveFiles(files){
            this.files = files
        },
        addToCart(){
            let cart = window.localStorage.getItem('cart')
            if(cart == null){
                cart = []
            }else{
                cart = JSON.parse(cart)
            }
            console.log(this.files);
            cart.push({id:cart.length+1 ,idea: this.texto, colores: this.dSelectedColor, precio:20})
            console.log(cart);
            window.localStorage.setItem('cart', JSON.stringify(cart))
        }
    }
}
</script>

<style scoped>
  .application{
    font-family: 'Josefin Sans', sans-serif;
  }
    .selectionColors{
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin: 5px;
    }

    .selectedColor {
        border: 2px solid black;
 
    }
</style>
